import type {
  CampaignCreatorRow,
  CampaignDeliverables,
} from '../types/creatorTabTypes';

/** Missing/unknown fulfillment states sort after actionable priorities 0–3. */
const UNKNOWN_FULFILLMENT_PRIORITY = 99;

/**
 * Lower values sort first (asc) — most actionable fulfillment rows on top.
 */
export function getFulfillmentActionPriority(
  creator: CampaignCreatorRow,
  deliverablesType: CampaignDeliverables
): number {
  const {fulfillmentState} = creator;

  if (!fulfillmentState) {
    return UNKNOWN_FULFILLMENT_PRIORITY;
  }

  if (deliverablesType === 'gift_codes') {
    if (fulfillmentState === 'awaiting_fulfillment') {
      return 0;
    }

    if (fulfillmentState === 'fulfilled') {
      return 2;
    }

    return 1;
  }

  if (fulfillmentState === 'awaiting_fulfillment') {
    return 0;
  }

  if (fulfillmentState === 'en_route') {
    return creator.trackingCodeInvalidatedAt ? 1 : 2;
  }

  if (fulfillmentState === 'fulfilled') {
    return 3;
  }

  return UNKNOWN_FULFILLMENT_PRIORITY;
}

export const FULFILLMENT_STATUS_SORT_ID = 'fulfillmentStatus';
export const TRACKING_CODE_SORT_ID = 'trackingCode';
export const GIFT_CODE_SORT_ID = 'giftCode';

export function getDefaultFulfillmentSortId(
  deliverablesType: CampaignDeliverables
): string {
  return deliverablesType === 'gift_codes'
    ? GIFT_CODE_SORT_ID
    : TRACKING_CODE_SORT_ID;
}

/**
 * Sorts by fulfillment action priority (missing tracking/code first), not by the
 * tracking number or gift code string. Ascending puts the most actionable rows on top.
 */
export function createFulfillmentActionSortOptions(
  deliverablesType: CampaignDeliverables
) {
  return {
    accessorFn: (row: CampaignCreatorRow) =>
      getFulfillmentActionPriority(row, deliverablesType),
    enableSorting: true,
    sortDescFirst: false,
  } as const;
}
